import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';
import { AppNotificationAlert, AppRemixIcon } from '@/layout/AppComponents';
import BreadcrumbHandler from '../../../layout/components/breadcrumb/BreadcrumbHandler';
import useIsMounted from '../../../layout/components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';
import { axiosPath } from '../../../routing/helpers/router';
import * as currentPageAction from '../../../store/actions/currentPageAction';
import AppSpinner from '@/layout/components/AppSpinner';
import SurveyBase from './SurveyBase';
import SurveySidebar from '../../../layout/screenSpecifics/Modules/Survey/Sidebar/SurveySidebar';

export default function SurveyHomeScreen() {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const moduleData = useSelector((s) => s?.module?.[moduleBridgeHex]?.moduleData);
  const [loading, setLoading] = useState(true);
  const [breadcrumb, setBreadcrumb] = useState();

  useEffect(() => {
    return () => {
      dispatch(currentPageAction.empty());
    };
  }, []);

  return (
    <>
      <SurveyBase />
      <SurveySidebar activeRoute="user_module_survey_home" />
      <BreadcrumbHandler
        paths={
          moduleData
            ? [{ name: moduleData?.moduleName }, { name: 'Inicio' }]
            : [{ name: '...' }]
        }
      />
      <main role="main" className="col-md-12 col-lg-12 px-md-4 mb-5">
        <div className="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-0 pb-0 mb-0"></div>
      </main>
    </>
  );
}
